export default "__VITE_ASSET__ELzwB4Wh__"